import * as yup from "yup";

const today = new Date();
today.setHours(0, 0, 0, 0);

export const VALIDATION_SCHEMA = yup.object({
  deal_name: yup.string().required("This field is required!"),
  project_manager_id: yup
    .number()
    .typeError("This field is required!")
    .required("This field is required!"),
  number_of_units: yup
    .number()
    .typeError("Must be a number!")
    .min(0, "Must be equal to or greater than 0!")
    .max(2147483647, "Must be less than 2147483647!")
    .required("This field is required!"),
});
